import { useContext, useEffect, useState } from 'react'
import { IResponse } from 'interfaces'
import useFetch from 'hooks/useFetch'
import { UserContext } from 'context/userContext'
import { Icon } from 'assets/index'
import {
  ActionCard,
  Kanban,
  Kanban2,
  Modal,
  NewModal,
  Path,
} from 'components/index'
import DeleteProposta from 'pages/Clientes/DeleteProposta'
import Detalhes from './Detalhes'
import { Container } from './style'

export default function Produtos() {
  const {
    kanbanData = [],
    setKanbanData,
    selectedId,
    data,
    setClientOption,
  } = useContext(UserContext)
  const [contractId, setContractId] = useState<string | null>()
  const [localModal, setLocalModal] = useState(false)

  const api = useFetch(
    `/gestor/kanban/private_contract?id=${selectedId.current}`
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response: IResponse = await api.fetch('get')
        console.log('deletar', response)
        if (response.fail) throw new Error(response.errors.message)
        setKanbanData(response.data.data)
      } catch (err: any) {
        console.log('err', err)
      }
    }

    fetchData()
  }, [])

  return (
    <Container>
      <Path className="path">
        <span className="path">{'Detalhes do cliente > Produtos'}</span>
      </Path>
      <h1 className="detalhes-captacao-title">{data.user.name}</h1>
      <div className="detalhes-container123">
        <h4 className="status-span">
          Conta {data.user.type === 'CPF' ? 'pessoa física' : 'pessoa jurídica'}
        </h4>
        <img
          className="status-icon"
          src={Icon('undefined.svg')}
          alt="status icon"
        />
        <span className="status-span">{data.account.status}</span>
      </div>

      <div className="status-card-container-cards">
        <ActionCard
          icon={Icon('profile.svg')}
          value={'Investimentos'}
          onClick={() => console.log('teste')}
        />
        <ActionCard
          disabled
          icon={Icon('token.svg')}
          value={'Token'}
          onClick={() => console.log('teste')}
        />
        <ActionCard
          disabled
          icon={Icon('building.svg')}
          value={'Empreendimento'}
          onClick={() => console.log('teste')}
        />
      </div>

      <h1 className="detalhes-captacao-title">Investimentos</h1>

      <div className="container-kanban">
        {kanbanData.length > 0 ? (
          <Kanban2
            onTrash={(id: any) => {
              setContractId(id)
              setLocalModal(true)
            }}
            handleClick={(cur) => {
              console.log(cur.id)
              setContractId(cur)
            }}
            investCard
            data={kanbanData}
            setData={setKanbanData}
          />
        ) : null}
      </div>

      <Modal
        backButton
        showModal={!!contractId}
        setShowModal={() => setContractId(null)}
      >
        {[
          [
            <Detalhes cur={contractId} />,
            'Detalhes do cliente > Produtos > Detalhes do investimento',
            (): void => {
              console.log('avançar 1')
            },
            (): void => {
              console.log('voltar 1')
            },
          ],
        ]}
      </Modal>
    </Container>
  )
}
